
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/demurrage-and-detention",
      function () {
        return require("private-next-pages/resources/demurrage-and-detention/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/demurrage-and-detention"])
      });
    }
  